import anonymousRepositoryHelper from './anonymousRepositoryHelper';

function ValidationRulesRepository() {

  var self = this;

  self.getValidationRules = function (resourceName) {

    var resourceUrl = 'api/validationRules/' + resourceName;
    return anonymousRepositoryHelper.ajaxGet(resourceUrl);
  };
}

export default new ValidationRulesRepository();
